import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@chama/ui-components/components/ModalNew';

import chamosoBad from '@chama/statics/assets/svg/chamoso-bad.svg';
import chamosoSuperBad from '@chama/statics/assets/svg/chamoso-super-bad.svg';
import chamosoGood from '@chama/statics/assets/svg/chamoso-good.svg';
import chamosoHappy from '@chama/statics/assets/svg/chamoso-happy.svg';
import chamosoHappyBuddha from '@chama/statics/assets/svg/chamoso-happy-buddha.svg';
import chamosoSuperHappy from '@chama/statics/assets/svg/chamoso-super-happy.svg';
import chamosoSuperHappyGreen from '@chama/statics/assets/svg/chamoso-super-happy-green.svg';
import chamosoWorried from '@chama/statics/assets/svg/chamoso-worried.svg';

import './ModalChamoso.css';

const ICONS = {
  bad: chamosoBad,
  'super-bad': chamosoSuperBad,
  good: chamosoGood,
  happy: chamosoHappy,
  'happy-buddha': chamosoHappyBuddha,
  'super-happy': chamosoSuperHappy,
  'super-happy-green': chamosoSuperHappyGreen,
  worried: chamosoWorried,
};

export default function ModalChamoso({ type, children, onClose, className }) {
  return (
    <Modal className={className} onClose={onClose}>
      <div className="ModalChamoso">
        <div className="ChamosoHeader">
          <div className="ChamosoHeader__icon-container">
            <img className="ChamosoHeader__icon" alt="Chamoso face!" src={ICONS[type]} />
          </div>
        </div>
        <div className="ModalChamoso__content">{children}</div>
      </div>
    </Modal>
  );
}
ModalChamoso.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  className: PropTypes.string,
};
ModalChamoso.defaultProps = {
  type: 'happy',
  onClose: Function.prototype,
  className: '',
};



// WEBPACK FOOTER //
// ../ui-components/components/ModalChamoso/ModalChamoso.jsx